import classnames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'

import styles from './Slugs.module.scss'

type SlugsProps<ITEM> = {
  items: ITEM[]
  max: number
  total: number
  render: (item: ITEM) => React.ReactNode
  className?: string
}

function Slugs<ITEM>({ items, max, total, render, className }: SlugsProps<ITEM>) {
  const { t } = useTranslation()
  return (
    <div className={classnames(styles.Slugs, className)}>
      {items.slice(0, total > max ? max - 1 : max).map(render)}
      {total > max && t('and <count> more', { count: total - max + 1 })}
    </div>
  )
}

export default React.memo(Slugs) as typeof Slugs
